import { cn } from '@skupreme/shared/ui';
import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';

export const InputFieldWrapper = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement> & { isVisible?: boolean }
>(({ isVisible, className, ...rest }, ref) => (
  <div
    {...rest}
    ref={ref}
    className={cn(!isVisible && 'sk:hidden', className) || undefined}
  />
));
InputFieldWrapper.displayName = 'InputFieldWrapper';

/*
 * A unit pinned inside a text field's right edge. The `!`s beat the Semantic
 * label and input rules these sit among.
 */
const INPUT_LABEL = cn(
  'sk:absolute sk:right-2 sk:ml-0! sk:flex! sk:h-[38px]! sk:items-center!',
  'sk:rounded-l-none! sk:border-l-0!',
);

export const InputLabel = forwardRef<
  HTMLSpanElement,
  HTMLAttributes<HTMLSpanElement>
>(({ className, ...rest }, ref) => (
  <span {...rest} ref={ref} className={cn(INPUT_LABEL, className)} />
));
InputLabel.displayName = 'InputLabel';

export const RightSemanticLabel = forwardRef<
  HTMLSpanElement,
  HTMLAttributes<HTMLSpanElement>
>(({ className, ...rest }, ref) => (
  <span
    {...rest}
    ref={ref}
    className={cn(
      'sk:absolute sk:right-px sk:ml-0! sk:flex! sk:h-9! sk:items-center!',
      'sk:rounded-l-none! sk:border-none!',
      className,
    )}
  />
));
RightSemanticLabel.displayName = 'RightSemanticLabel';

type FormLabelProps = {
  info_tooltip?: string;
  requried?: boolean;
  children?: ReactNode;
  className?: string;
  label?: string;
};

export function FormLabel({
  requried,
  children,
  label,
  info_tooltip: _infoTooltip,
  className,
}: FormLabelProps) {
  return (
    <div className={cn('sk:mt-2.5', className)}>
      {children}
      {label && <span>{label}</span>}
      {requried && <span className="sk:text-danger">*</span>}
    </div>
  );
}
